// Initial board content. Used by the server to seed a fresh Y.Doc when a
// board has no shapes yet. Production replaces this with template-driven
// seeding (Day 17+); for now it gives Day 2+3 something to drag around.

import type { Shape } from './shapes.js';

export const seedShapes: Shape[] = [
  {
    id: 'frame-1',
    type: 'frame',
    x: 80, y: 80,
    w: 320, h: 480,
    label: 'Start',
    authorId: 'seed',
    createdAt: 0,
  },
  {
    id: 'frame-2',
    type: 'frame',
    x: 440, y: 80,
    w: 320, h: 480,
    label: 'Stop',
    authorId: 'seed',
    createdAt: 0,
  },
  {
    id: 'frame-3',
    type: 'frame',
    x: 800, y: 80,
    w: 320, h: 480,
    label: 'Continue',
    authorId: 'seed',
    createdAt: 0,
  },
  {
    id: 'sticky-1',
    type: 'sticky',
    x: 110, y: 130,
    w: 200, h: 160,
    color: 'sand',
    text: 'pair more on hard tickets',
    authorId: 'seed',
    createdAt: 0,
  },
  {
    id: 'sticky-2',
    type: 'sticky',
    x: 130, y: 320,
    w: 200, h: 160,
    color: 'sage',
    text: 'thursday async standup felt good',
    authorId: 'seed',
    createdAt: 0,
  },
  {
    id: 'sticky-3',
    type: 'sticky',
    x: 470, y: 130,
    w: 200, h: 160,
    color: 'rose',
    text: 'last-minute scope changes mid-sprint',
    authorId: 'seed',
    createdAt: 0,
  },
  {
    id: 'sticky-4',
    type: 'sticky',
    x: 830, y: 130,
    w: 200, h: 160,
    color: 'fog',
    text: 'design review cadence',
    authorId: 'seed',
    createdAt: 0,
  },
  {
    id: 'sticky-5',
    type: 'sticky',
    x: 850, y: 320,
    w: 200, h: 160,
    color: 'dusk',
    text: 'weekly demo to stakeholders',
    authorId: 'seed',
    createdAt: 0,
  },
  {
    id: 'rect-1',
    type: 'rect',
    x: 200, y: 660,
    w: 200, h: 80,
    fill: '#ffffff',
    stroke: '#1a1a1a',
    text: 'Process',
    authorId: 'seed',
    createdAt: 0,
  },
  {
    id: 'ellipse-1',
    type: 'ellipse',
    x: 480, y: 660,
    w: 180, h: 80,
    fill: '#ffffff',
    stroke: '#1a1a1a',
    text: 'Decision',
    authorId: 'seed',
    createdAt: 0,
  },
];
